import GrantsRadarTab from "../components/grants/GrantsRadarTab";
import GrantApplicationsSection from "../components/grants/GrantApplicationsSection";

export default function GrantsPage() {
  return (
    <div className="space-y-6 animate-in" data-testid="grants-page">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Subvenciones</h1>
          <p className="text-muted-foreground mt-1">
            Radar automático de convocatorias públicas (CDTI, Horizon, LIFE) + manuales, con seguimiento de solicitudes por proyecto
          </p>
        </div>
      </div>
      <GrantApplicationsSection />
      <GrantsRadarTab />
    </div>
  );
}
